import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import AppNavigation from "../navigation/AppNavigation";

const Fsn223WebView = ({ onTap }) => {

  const { handleNavigation } = AppNavigation();
  const location = useLocation();
  const navigate = useNavigate(); // Initialize navigation
  const currentQueryParams = new URLSearchParams(window.location.search);

  const appendQueryParams = (url) => {
    try {
      const iframeUrl = new URL(url);
      currentQueryParams.forEach((value, key) => {
        iframeUrl.searchParams.append(key, value);
      });
      return iframeUrl.toString();
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  };
  
  if (!onTap?.FAI) {
    return <p>No FAI data provided</p>;
  }
  
  let faiObject;
  try {
    faiObject = JSON.parse(decodeURIComponent(onTap.FAI));
  } catch (error) {
    faiObject=onTap.FAI;
  }
  
  if (!faiObject.url) {
    return <p>No URL provided in FAI object</p>;
  }
  

  const handleMenuClick = () => {
    const menuOnTap = faiObject.menu?.onTap;

    console.log("Menu onTap before adding NavigationType:", menuOnTap);

    if (menuOnTap) {
      // Set NavigationType to 3
      const menuOnTapWithNavigationType = {
        ...menuOnTap,
        NavigationType: "3",
      };

      console.log("Menu onTap with NavigationType set to 3:", menuOnTapWithNavigationType);
      handleNavigation(menuOnTapWithNavigationType); // Navigate using handleNavigation
    } else {
      console.log("No menu onTap data found.");
    }
  };

  const urlWithParams = appendQueryParams(faiObject.url);
  if (!urlWithParams) {
    return <p>Failed to construct the iframe URL</p>;
  }

  // Function to handle the back button
  const handleBackButtonPress = () => {

    if (window.Android) {
      // Call Android's Java function via the bridge
      window.Android.onBackPressed();
    } else {
      navigate(-1); // Navigate back
    }
  };

  return (
    <div className="App">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "10px 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #ddd",
        }}
      >
        <ArrowBackIosIcon sx={{ cursor: "pointer" }} onClick={handleBackButtonPress} />
        <Typography variant="h6" sx={{ flexGrow: 1, textAlign: "center" }}>
          {onTap?.FAI?.title || "GOQii"}
        </Typography>
        {faiObject.menu?.icon && (
          <img
            src={faiObject.menu.icon}
            alt="Menu Icon"
            style={{ cursor: "pointer", height: "24px", width: "24px" }}
            onClick={handleMenuClick}
          />
        )}
      </Box>

      <iframe
        src={urlWithParams}
        title="Referral Page"
        style={{
          width: "100%",
          height: "90vh",
          border: "none",
        }}
      ></iframe>
    </div>
  );
};

export default Fsn223WebView;